(function () {
  

})();
class CountryPopup extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    this.CONFIG = {
      COOKIE_SELECTED: "geo_market_selected",
      COOKIE_COUNTRY: "geo_shipping_country",
      COOKIE_MAX_AGE: 60 * 60 * 24 * 365, // 1 year
      GEO_TIMEOUT: 7000
    };
    this.MARKET_MAP = __SHOPIFY_MARKET_MAP__
    this.init()
  }

  /* =========================
     GEO RESOLUTION
  ========================== */

  

  showModal() {
    const modal = document.getElementById("geo-modal");
    if (!modal) return;
    modal.style.display = "block";
    lockBody();
  }

  /* =========================
     MARKET SWITCH (SHOPIFY)
  ========================== */

  switchMarket(countryCode) {
    setCookie(this.CONFIG.COOKIE_SELECTED, "1", this.CONFIG.COOKIE_MAX_AGE);
    setCookie(this.CONFIG.COOKIE_COUNTRY, countryCode, this.CONFIG.COOKIE_MAX_AGE);

    const form = document.getElementById("localization_form");
    form.submit();
  }

  /* =========================
     INIT MODAL EVENTS
  ========================== */

  initModalEvents() {
    const select = document.getElementById("geo-country-select");
    const button = document.getElementById("geo-proceed-btn");

    if (!select || !button) return;

    select.addEventListener("change", () => {
      button.disabled = !select.value;
    });

    button.addEventListener("click", () => {
      if (!select.value) return;
      this.switchMarket(select.value);
    });
  }

  /* =========================
     MAIN FLOW
  ========================== */

  async init() {
    if (isBot()) return;
    if (hasMarketInURL()) return;
    if (getCookie(this.CONFIG.COOKIE_SELECTED)) return;

    this.initModalEvents();

    // Safari strategy: skip geo, show modal directly
    if (isSafari()) {
      this.showModal();
      return;
    }

    try {
      const pos = await resolveGeolocation(this.CONFIG.GEO_TIMEOUT);
      const country = await reverseGeoToCountry(
        pos.coords.latitude,
        pos.coords.longitude
      );

      if (!country || !this.MARKET_MAP[country]) {
        this.showModal();
        return;
      }

      document.getElementById('geo-country-select').value = country;
      this.switchMarket(country);

    } catch (e) {
      console.log(e,123)
      this.showModal();
    }
  }
}
customElements.define('country-popup',CountryPopup)
function isBot() {
  return /bot|crawler|spider|crawling/i.test(navigator.userAgent);
}
function setCookie(name, value, maxAge) {
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`;
  }

function getCookie(name) {
  return document.cookie
    .split("; ")
    .find(row => row.startsWith(name + "="))
    ?.split("=")[1];
}

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function hasMarketInURL() {
  return window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}/i);
}
function resolveGeolocation(GEO_TIMEOUT) {
    return new Promise((resolve, reject) => {
      if (!("geolocation" in navigator)) {
        reject("GEO_NOT_SUPPORTED");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position => resolve(position),
        error => reject(error),
        {
          enableHighAccuracy: false,
          timeout: GEO_TIMEOUT,
          maximumAge: 0
        }
      );
    });
  }

  function reverseGeoToCountry(lat, lng) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;

    return fetch(url, {
      headers: {
        "Accept": "application/json"
      }
    })
      .then(r => r.json())
      .then(data => data?.address?.country_code?.toUpperCase() || null)
      .catch(() => null);
  }

  /* =========================
     MODAL CONTROL
  ========================== */

  function lockBody() {
    document.body.style.overflow = "hidden";
  }